import { i18n } from '@lingui/core'

export function NoOrdersFound() {
  return (
    <div className='flex h-full min-h-[200px] w-full items-center justify-center'>
      <span className='Type-XXL-Regular md:Type-XXL-Regular italic md:italic'>
        {i18n._('No Orders Found')}
      </span>
    </div>
  )
}
